import React, { useState } from "react";

import Swal from "sweetalert2";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

//Feather
import {
  AlertTriangle
} from "react-feather";

import {
  CBadge,
  CDropdown,
  CFormCheck,
  CDropdownMenu,
  CDropdownItem,
  CDropdownToggle,
  //Table
  CAvatar,
  CTableRow,
  CTableDataCell,
  CTableHeaderCell
} from "@coreui/react";

import { useAuth } from "../providers/auth";

import api from "../services/api";
import CustomerTable from "./CustomerTable";

export default function CustomerTableItem({ mutations, setCustomerId, setOpenChat, setTriggers, setButtonPopupSocialMediaFilter, pegaSocialMedia, customer, transferCustomer, index, fetchCustomerById, setButtonJoinClients, selectedCustomer, setSelectedCustomer, onChangeCheck, checkbox }) {
  const { user } = useAuth();
  const canTransferCustomer = typeof transferCustomer === "function";

  const [, setIsApprovedLoading] = useState(false);
  const [toggleApproved, setToggleApproved] = useState(customer.approved);
  const isApproved = toggleApproved ? "success" : "danger";
  const isApprovedText = toggleApproved ? "Aprovado" : "Desaprovado";

  const [, setIsActiveLoading] = useState(false);
  const [toggleActive, setToggleActive] = useState(customer.status);
  const isActive = toggleActive ? "success" : "danger";
  const isActiveText = toggleActive ? "Ativo" : "Desativado";
  const [isChatCheckLoading, setIsChatCheckLoading] = useState(false);
  const currentUserId = Number(user?.id || 0);
  const linkedSellerId = Number(customer?.currentAdmin_id || customer?.admin_id || 0);
  const hasLinkedSeller = linkedSellerId > 0;
  const transferCustomerLabel = hasLinkedSeller ? "Transferir cliente" : "Selecionar vendedor";

  function handleFetchCustomerById(id) {
    fetchCustomerById(id);
  }

  async function handleApprove() {
    const isApproved = toggleApproved ? 0 : 1;

    setIsApprovedLoading(true);

    try {
      await api.post("/users/edit", {
        "user_id": customer.id,
        "body": {
          "approved": isApproved
        }
      }, { headers: { "Authorization": "Bearer " + user.token } });


    } catch (error) { console.log(error); } finally {
      setIsApprovedLoading(false);
    }
  }

  async function handleStatus() {
    const isActive = toggleActive ? 0 : 1;

    setIsActiveLoading(true);

    try {
      await api.post("/users/edit", {
        "user_id": customer.id,
        "body": {
          "status": isActive
        }
      }, { headers: { "Authorization": "Bearer " + user.token } });

    } catch (error) { console.log(error); } finally {
      setIsActiveLoading(true);
    }
  }

  function join_customer(e, customer) {
    e.preventDefault();
    setButtonJoinClients(true);
    setSelectedCustomer(customer);
  }

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    }
  });

  const openAlert = (icon, title, text) => {
    Toast.fire({
      icon,
      title,
      text
    });
  };

  async function freeCustomer() {
    selectedCustomer(customer);
    try {
      var response = await api.post("/users/free_customer", {
        "user_id": customer.id
      }, {
        headers: { "Authorization": "Bearer " + user.token }
      });
      let icon = "success";
      let title = "Cliente Disponibilizado";
      openAlert(icon, title, response.data.message);
    } catch (error) {
      let icon = "error";
      let title = "Ocorreu um erro";
      openAlert(icon, title, error);
    }
  }

  /**
     *
     *
     * Functions
     */
  const getLinkedSellerId = data => Number(data?.currentAdmin_id || data?.admin_id || 0);

  const getLinkedSellerName = data => {
    const sellerName = data?.adminname || data?.name_admin || customer?.adminname || customer?.name_admin;

    return sellerName && sellerName !== "--//--" ? sellerName : "outro vendedor";
  }

  const handleGetSocialMedia = () => {
    mutations.socialMediaMutation.mutate(customer.id);
    setCustomerId(customer.id);
    setTriggers.setMediaTrigger(true);
  }

  const handleOpenChat = async event => {
    event.preventDefault();

    setIsChatCheckLoading(true);

    try {
      const response = await api.get(`/users/${customer.id}`, {
        headers: { "Authorization": "Bearer " + user.token }
      });
      const updatedCustomer = response.data || customer;
      const currentLinkedSellerId = getLinkedSellerId(updatedCustomer);
      const linkedToOtherSeller = currentLinkedSellerId > 0 && currentLinkedSellerId !== currentUserId;
      const sellerActionLabel = currentLinkedSellerId > 0 ? "Transferir cliente" : "Selecionar vendedor";

      if (linkedToOtherSeller) {
        Swal.fire({
          icon: "warning",
          title: "Cliente com vendedor vinculado",
          text: `Este cliente já está vinculado ao vendedor ${getLinkedSellerName(updatedCustomer)}. Para trocar o responsável, use "${sellerActionLabel}" no menu ao lado.`,
          confirmButtonText: "Entendi"
        });
        return;
      }

      const result = await Swal.fire({
        icon: "info",
        title: "Abrir chat para você?",
        text: currentLinkedSellerId > 0
          ? "O chat será aberto para você."
          : "Este cliente ainda não tem vendedor vinculado. O chat será aberto e o cliente será vinculado a você.",
        showCancelButton: true,
        confirmButtonText: "Abrir chat",
        cancelButtonText: "Cancelar"
      });

      if (result.isConfirmed) {
        handleGetSocialMedia();
      }
    } catch {
      openAlert("error", "Ocorreu um erro", "Não foi possível conferir o vendedor vinculado deste cliente.");
    } finally {
      setIsChatCheckLoading(false);
    }
  }

  return (
    <CTableRow key={index}>
      {checkbox && <CTableHeaderCell scope="row">
        <CFormCheck name="customers" value={customer.id} checked={customer.checked} onChange={event => onChangeCheck(event, customer)} />
      </CTableHeaderCell>}
      <CTableHeaderCell scope="row">
        <CAvatar color="light" textColor="dark" style={{ backgroundImage: `url(${customer.profile_pic})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}></CAvatar>
      </CTableHeaderCell>
      <CTableDataCell onClick={() => handleFetchCustomerById(customer.id)}>
        {customer.name} {customer.juridic && (<AlertTriangle style={{ color: "red" }} size={18} />)} {customer.link_usadao ? <CBadge style={{ marginLeft: "15px" }} color="warning" href={customer.link_usadao}>#{customer.usadao_id}</CBadge> : <CBadge style={{ marginLeft: "15px" }} color="dark">Sem cadastro</CBadge>}
      </CTableDataCell>
      <CTableDataCell>
        {customer.link_usadao ? <CBadge textColor="dark" href={customer.link_usadao}>{moment(customer.ultimaVizualizacao).format("H:mm:ss - D MMMM YYYY")}</CBadge> : <CBadge style={{ marginLeft: "15px" }} textColor="dark" >--</CBadge>}
      </CTableDataCell>
      <CTableDataCell>
        {customer.usadao_id && <CBadge color={isApproved} onClick={() => { setToggleApproved(!toggleApproved); handleApprove(customer.id) }}>{isApprovedText}</CBadge>}
      </CTableDataCell>
      <CTableDataCell>
        {customer.usadao_id && <CBadge color={isActive} onClick={() => { setToggleActive(!toggleActive); handleStatus(customer.id) }}>{isActiveText}</CBadge>}
      </CTableDataCell>
      <CTableDataCell>
        <div align="center">
          <button className="btn btn-warning" type="button" onClick={handleOpenChat} disabled={isChatCheckLoading}>
            {isChatCheckLoading ? "..." : "+Chat"}
          </button>
        </div>
      </CTableDataCell>
      <CTableDataCell>
        <CDropdown>
          <CDropdownToggle color="light mr-10 bg-transparent" style={{ margin: "-15px" }}></CDropdownToggle>
          <CDropdownMenu>
            {/*
                <CDropdownItem
                    href="#"
                    onClick={JoinCustomers}>
                    Unir com outro cliente
                </CDropdownItem>
                <CDropdownItem href="#">Editar redes sociais</CDropdownItem>
                */}
            <CDropdownItem href="#" onClick={freeCustomer}>Disponibilizar cliente</CDropdownItem>
            {canTransferCustomer && <CDropdownItem href="#" onClick={e => { e.preventDefault(); transferCustomer(customer); }}>{transferCustomerLabel}</CDropdownItem>}
            <CDropdownItem href="#" onClick={e => join_customer(e, customer)}>Unificar cliente</CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
      </CTableDataCell>
    </CTableRow>
  )
}

CustomerTable.defaultProps = {
  checkbox: true
}
